import downloadFile from './downloadFile';

export default downloadFile;
